import * as Yup from 'yup';
import { FileRef } from '@eas/common-web';
import { Certificate } from '@models';

export function useValidationSchema() {
  return Yup.object<Certificate>().shape({
    name: Yup.string().nullable().required(),
    password: Yup.string().nullable().required(),
    content: Yup.object<FileRef>().nullable().required(),
  });
}
